/** API route map: URLS.Controller.PayrollSutaSetup */
export const PayrollSutaSetup = {
      Name: 'PayrollSutaSetup/',
      GetAll: 'getall',
      GetAllByClient: 'get-all-by-client',
      Add: 'add',
      Delete: 'delete',
      Update: 'update',
      GetSuta: 'get-suta',
      UpdateSuta: 'update-suta',
      GetSutaclients: 'get-clients',
      GetSutaMatched: 'get-suta-matched',
};
